import { render, staticRenderFns } from "./AdminContractDetail.vue?vue&type=template&id=546754a0&scoped=true"
import script from "./AdminContractDetail.vue?vue&type=script&lang=js"
export * from "./AdminContractDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminContractDetail.vue?vue&type=style&index=0&id=546754a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546754a0",
  null
  
)

export default component.exports